import { render, staticRenderFns } from "./ExpenseEditPage.vue?vue&type=template&id=63711622&"
import script from "./ExpenseEditPage.vue?vue&type=script&lang=js&"
export * from "./ExpenseEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports